$(document).on('click', '#sidebarCollapse', function () {
  $('#sidebar').addClass('active');
  $('.overlay').addClass('active');
});

$(document).on('click', '#dismiss, .overlay', function () {
  $('#sidebar').removeClass('active');
  $('.overlay').removeClass('active');
});
